import { FC } from "react";
import { FieldErrors } from "react-hook-form";

import { useAccumulatedTranslatedFormFieldMessages } from "../error-display/use-accumulated-translated-form-field-messages";
import { MessagesDisplayItem } from "./messages-display.item";
import { IMessagesType } from "./messages-display.models";

interface IMessagesDisplayFormsContainer {
  formMessages: FieldErrors | undefined;
  type: IMessagesType;
}

export const MessagesDisplayFormsContainer: FC<
  IMessagesDisplayFormsContainer
> = ({ formMessages, type }: IMessagesDisplayFormsContainer) => {
  const messageList = useAccumulatedTranslatedFormFieldMessages(formMessages);

  return messageList?.map(({ path, message }) => {
    return (
      <MessagesDisplayItem
        key={`${path}_${message}`}
        messageDescription={message}
        type={type}
      />
    );
  });
};
